import { render, staticRenderFns } from "./QuadroHorarioSalaNormal.vue?vue&type=template&id=834bf2fc&scoped=true&"
import script from "./QuadroHorarioSalaNormal.vue?vue&type=script&lang=js&"
export * from "./QuadroHorarioSalaNormal.vue?vue&type=script&lang=js&"
import style0 from "./QuadroHorarioSalaNormal.vue?vue&type=style&index=0&id=834bf2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834bf2fc",
  null
  
)

export default component.exports